import { setJwtToken } from '@/helpers/setRequestHeaders'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

type ApplicationCategories = {
    id: number
    title: string  
    value: string
    application?: any
}

type ApplicationCategoriesDto = {
    title: string  
    value: string
}

export const ApplicationCategoriesApi = createApi({
    reducerPath: 'ApplicationCategoriesApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT || 'http://megakorm.ru:3005/api',
        prepareHeaders: setJwtToken
    }),
    tagTypes: ["APPLICATION-CATEGORIES"],
    endpoints: builder => ({
        getApplicationCategories: builder.query<ApplicationCategories, { id: number }>({
            query: id => ({ url: `/application-categories/${id}` }),
            providesTags: ["APPLICATION-CATEGORIES"],
        }),
        getAllApplicationCategories: builder.query<ApplicationCategories[], void>({
            query: () => ({ url: '/application-categories' }),
            providesTags: ["APPLICATION-CATEGORIES"],
        }),
        createApplicationCategories: builder.mutation<any, ApplicationCategoriesDto>({
            query: (data)=> ({url: `/application-categories`, method: "POST", body: data}),
            invalidatesTags: ["APPLICATION-CATEGORIES"],
        }),
    })
})

export const { useGetApplicationCategoriesQuery, useGetAllApplicationCategoriesQuery, useCreateApplicationCategoriesMutation } = ApplicationCategoriesApi
